<template>
	<div>
		<!-- GA Date -->
		<transition name="date-transition">
			<div
				v-if="tourOptions[0].dates.length > 0"
				ref="calendar"
				class="tLeft__date tLeft__flexUl"
			>
				<h2 class="tLeft__h2">2. Select a date</h2>
				<p class="tLeft__p">Select an upcoming date from the calendar below</p>

				<div class="evModal__cal">
					<EventPicker
						class="homePicker__dp datePick"
						v-model="datePicked"
						:disabled-dates="this.tourOptions[0]"
						model-type="yy-m-d"
						inline
						auto-apply
					></EventPicker>
				</div>
			</div>
		</transition>
		<transition name="date-transition">
			<div
				ref="tourTickets"
				v-if="mergedPrices"
				class="tLeft__date tLeft__flexUl"
			>
				<h2 class="tLeft__h2">3. Select tickets</h2>
				<p class="tLeft__p">Select your tickets for the tour</p>
				<div class="tLeft__flexUl">
					<div
						v-for="(ticket, index) in visibleTickets"
						v-bind:key="ticket.id"
						:class="[ticket.count > 0 ? 'tLeft__ticketSelected' : '']"
						class="tLeft__li tLeft__li--ticketType"
					>
						<div class="tLeft__tickId">
							<p class="tLeft__ticketName">{{ ticket.title }}</p>
							<p class="tLeft__ticketHelp">{{ ticket.helperText }}</p>
						</div>
						<div class="tLeft__rightTicketCont">
							<p class="tLeft__money">${{ ticket.price }}</p>
							<div class="tLeft__ticketRight">
								<div class="tLeft__calc">
									<div class="tLeft__ticketBtn" @click="removeTicket(index)">
										<div v-if="ticket.count > 0">
											<MinusActive></MinusActive>
										</div>
										<div v-else><MinusInactive></MinusInactive></div>
									</div>
									<p class="tLeft__val">{{ ticket.count }}</p>
									<div class="tLeft__ticketBtn" @click="addTicket(index)">
										<div v-if="ticket.count > 0">
											<PlusActive></PlusActive>
										</div>
										<div v-else><PlusInactive></PlusInactive></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<p
						class="tLeft__p tLeft__p--show"
						v-if="!showAllTickets"
						@click="showAllTickets = true"
					>
						Show more ticket types
						<ShowMoreCarrot></ShowMoreCarrot>
					</p>
					<p
						class="tLeft__p tLeft__p--show"
						v-if="showAllTickets"
						@click="showAllTickets = false"
					>
						Show less ticket types
						<ShowMoreCarrot class="upsideDown"></ShowMoreCarrot>
					</p>
				</div>
			</div>
		</transition>
		<transition name="date-transition">
			<div class="tLeft__yyt" v-if="ticketCount > 0 && performanceZones">
				<div class="tLeft__step5">
					<div class="tLeft__step5left">
						<h2 class="tLeft__h2">4. Select a time</h2>
						<p class="tLeft__p">
							Ropes Mansion Tours are timed events, please choose accordingly
							from the available times
						</p>
					</div>
				</div>
				<div class="tLeft__yyTimes">
					<div
						class="tLeft__yyTime"
						:class="[
							selectedZone === zone.zone ? 'tLeft__yyTimeSelected' : '',
							selectedZone === null ? '' : '',
						]"
						@click="settingZone(index)"
						v-for="(zone, index) in performanceZones"
						v-bind:key="zone.zone"
					>
						<p>
							{{ zone.time }}
						</p>
					</div>
				</div>
			</div>
		</transition>

		<transition name="date-transition">
			<div v-if="ticketCount > 0 && selectedZone" class="tLeft__addTickets">
				<button class="tLeft__addTicketsBtn" @click="addRopesToCart">
					<p>Add to Cart</p>
				</button>
			</div>
		</transition>
	</div>
</template>
<script>
import { set } from 'vue';
import MinusActive from './svg/MinusActive';
import MinusInactive from './svg/MinusInactive';
import PlusActive from './svg/PlusActive';
import PlusInactive from './svg/PlusInactive';
import Datepicker from 'vuejs-datepicker';
import ShowMoreCarrot from './svg/ShowMoreCarrot';

export default {
	name: 'Tours',
	props: {
		sessionKey: String,
	},
	components: {
		EventPicker: Datepicker,
		PlusActive,
		PlusInactive,
		MinusActive,
		MinusInactive,
		ShowMoreCarrot,
	},
	data() {
		return {
			amountOfTicketsToShow: 4,
			startDate: null,
			dateToFind: null,
			endDate: null,
			eventId: null,
			mergedPrices: null,
			performanceZones: null,
			priceTypes: null,
			rawDataEvents: null,
			validDates: null,
			datePicked: null,
			selectedZone: null,
			showAllTickets: false,
			ticketDisplayOrder: [2, 11, 10, 152, 6, 9, 125, 7, 129, 159],
			ticketTextInfo: null,
			ticketsArray: [],
			allowedPricetypes: [2, 11, 10, 152, 9, 125, 129, 6, 7, 159],
			tourOptions: [
				{
					to: new Date(),
					from: new Date(),
					dates: [],
				},
			],
		};
	},
	beforeMount() {
		this.checkParams();
	},
	mounted() {
		this.getDates();
	},
	methods: {
		addRopesToCart() {
			let ropesData = {
				eventId: this.eventId,
				session: this.sessionKey,
				totalTickets: this.ticketCount,
				priceTypes: this.ticketsArray.join(','),
				zoneId: this.selectedZone,
			};
			this.$emit('reserveRopesOnly', ropesData);
			this.resetTourValues();
		},
		resetTourValues() {
			this.amountOfTicketsToShow = 4;
			this.startDate = null;
			this.dateToFind = null;
			this.endDate = null;
			this.eventId = null;
			this.mergedPrices = null;
			this.performanceZones = null;
			this.priceTypes = null;
			this.rawDataEvents = null;
			this.validDates = null;
			this.datePicked = null;
			this.selectedZone = null;
			this.showAllTickets = false;
			this.ticketTextInfo = null;
		},
		resetOnDatePicked() {
			this.ticketsArray = [];
			this.selectedZone = null;
		},
		checkParams() {
			const windowLocation = window.location.search;
			const urlParams = new URLSearchParams(windowLocation);
			const date = urlParams.get('date');
			if (date) {
				let newDate = date + 'T10:00:00Z';
				newDate.toLocaleString('en-US', { timeZone: 'America/New_York' });
				this.dateToFind = new Date(newDate);
			}
		},
		getDates() {
			const toESTMidnightUTC = (date) => {
				const estDateStr = new Intl.DateTimeFormat('en-US', {
					timeZone: 'America/New_York',
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				}).format(date);

				const [month, day, year] = estDateStr.split('/');
				const estMidnight = new Date(`${year}-${month}-${day}T00:00:00-05:00`); // -05:00 is EST offset

				return estMidnight.toISOString(); // Convert to UTC timestamp
			};

			const today = new Date();

			const yesterday = new Date(today);
			yesterday.setDate(yesterday.getDate() - 1);

			const sixMonthsFromNow = new Date(today);
			sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);

			this.startDate = toESTMidnightUTC(yesterday);
			this.endDate = toESTMidnightUTC(sixMonthsFromNow);
		},
		getTessEvents() {
			this.rawDataEvents = [];
			this.validDates = [];
			let that = this;
			// use the calendar start and end dates and get the tess events for that week or for mobile: month
			$.get(
				'/actions/my-module/default/get-tess-events',
				{ start: this.startDate, end: this.endDate },
				function (res) {
					let jsonData = JSON.parse(res);
					// return the Events and programs
					let now = new Date();
					jsonData.forEach((el) => {
						let startDate = new Date(el.ModeOfSaleStartDate);
						if (
							el.ProductionSeason.Description.includes('Ropes Mansion') &&
							now >= startDate
						) {
							that.rawDataEvents.push(el);
						}
					});
				}
			);
		},
		getInvalidDates(startDate, endDate, dateArray) {
			let invalidDates = [];
			let currentDate = new Date(startDate);
			let end = new Date(endDate);

			// Convert dateArray to a Set of normalized dates (YYYY-MM-DD) for quick lookup
			let dateSet = new Set(
				dateArray.map((date) => new Date(date).toDateString()) // Normalize to date string format
			);

			while (currentDate <= end) {
				let formattedDate = currentDate.toDateString(); // Normalize format

				// If the date is missing, store it as an invalid date
				if (!dateSet.has(formattedDate)) {
					invalidDates.push(
						new Date(
							currentDate.getFullYear(),
							currentDate.getMonth(),
							currentDate.getDate()
						)
					);
				}

				currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
			}

			return invalidDates;
		},
		getTheCalendarPluginOptions(dateArray) {
			if (dateArray !== null && dateArray.length > 0) {
				let sortedArray = dateArray.sort(
					(a, b) => new Date(a.PerformanceDate) - new Date(b.PerformanceDate)
				);

				// filter past dates out
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				let filteredArray = (dateArray = sortedArray.filter((obj) => {
					const eventDate = new Date(obj.date);
					return eventDate >= today; // Keep only events that are today or in the future
				}));

				this.mergedData = filteredArray;

				// set the Datepicked on the Calendar
				let datePickTime = new Date(filteredArray[0].date);
				datePickTime.setHours(0, 0, 0, 0);
				this.datePicked = datePickTime.getTime();

				// find the valid dates for the calendar in order to find the invalid dates (this.getInvalidDates())
				let validDatesArray = [];
				let today2 = new Date();
				today2 = today.setDate(today.getDate() - 1);
				today2 = new Date(today);
				filteredArray.forEach((el) => {
					let elDate = new Date(el.date);
					if (elDate >= today) {
						validDatesArray.push(elDate);
					}
				});

				let startDate = new Date(filteredArray[0].date);
				let endDate = new Date(filteredArray[filteredArray.length - 1].date);

				// give the calendar an array of dates to block out
				this.vueDatepickerOptions[0].dates = this.getInvalidDates(
					startDate,
					endDate,
					validDatesArray
				);
				// set the Start Date of the Calendar
				startDate.setDate(startDate.getDate() - 1);
				this.vueDatepickerOptions[0].to = startDate;

				// set the End Date of the Calendar
				this.vueDatepickerOptions[0].from = endDate;
			}
		},
		getMissingDates(startDate, endDate, dateArray) {
			const missingDates = [];

			// Convert start and end to Date objects
			let current = new Date(startDate);
			let end = new Date(endDate);

			// Normalize time to midnight
			current.setHours(0, 0, 0, 0);
			end.setHours(0, 0, 0, 0);

			// Create a Set of normalized YYYY-MM-DD strings for fast lookup
			const dateSet = new Set(
				dateArray.map((d) => new Date(d).toISOString().split('T')[0])
			);

			while (current <= end) {
				const isoString = current.toISOString().split('T')[0]; // 'YYYY-MM-DD'

				if (!dateSet.has(isoString)) {
					// Push the Date object if not found in dateSet
					missingDates.push(new Date(current));
				}

				// Move to next day
				current.setDate(current.getDate() + 1);
			}

			return missingDates;
		},
		getPerformanceZones(id) {
			if (id === null || id === undefined) {
				return;
			}
			let that = this;
			$.get(
				'/actions/my-module/default/available-tickets-check',
				{ arrayOfIds: that.eventId },
				function (res) {
					let jsonData = JSON.parse(res);
					let eligible = jsonData.filter(function (item) {
						return item.Zone.ZoneMapId !== 72;
					});
					eligible = eligible
						.filter((item) => item.Zone.Description !== 'Unassigned')
						.filter((item) => item.AvailableCount > 0)
						.map((item) => ({
							time: item.Zone.Description.toLowerCase(),
							availableCount: item.AvailableCount,
							id: item.PerformanceId,
							zone: item.Zone.Id,
						}));

					that.performanceZones = eligible;
				}
			);
		},
		getPriceTypes() {
			let that = this;
			$.get(
				'/actions/my-module/default/get-all-price-types',
				{ gaPerformanceId: that.eventId },
				function (res) {
					let jsonRes = JSON.parse(res);
					let filteredPriceTypes = jsonRes;
					// filter All price types numerical info (ids) by the allowed pricetypes array

					filteredPriceTypes = filteredPriceTypes.filter(
						(item) => that.allowedPricetypes.indexOf(item.PriceTypeId) !== -1
					);

					let filteredArray = [];
					filteredPriceTypes.forEach((price) => {
						filteredArray.push({
							limit: 6,
							id: price.PriceTypeId,
							count: 0,
							price: price.PerformancePrices[0].Price,
							zoneId: price.PerformancePrices[0].ZoneId,
						});
					});
					that.priceTypes = filteredArray;
				}
			);
		},
		getTicketText() {
			let that = this;
			let filteredArray = [];
			$.get('/actions/my-module/default/get-ga-ticket-text', function (res) {
				let jsonRes = JSON.parse(res);

				// filter All price type text info price types by the allowed pricetypes array and create array of objects with the info
				let filteredText = [];
				filteredText = jsonRes.filter(
					(item) => that.allowedPricetypes.indexOf(item.Id) !== -1
				);
				filteredText.forEach((price) => {
					filteredArray.push({
						id: price.Id,
						title: price.Description,
						helperText: price.AliasDescription,
					});
				});
			});
			that.ticketTextInfo = filteredArray;
		},
		mergeTicketValues(text) {
			if (!this.ticketTextInfo || !this.priceTypes) {
				return;
			}
			let prices = this.priceTypes
				.filter((obj1) =>
					this.ticketTextInfo.some((obj2) => obj2.id === obj1.id)
				)
				.map((obj1) => {
					const obj2 = this.ticketTextInfo.find((o) => o.id === obj1.id);
					return { ...obj1, ...obj2 };
				});
			this.mergedPrices = prices.sort((a, b) => {
				return (
					this.ticketDisplayOrder.indexOf(a.id) -
					this.ticketDisplayOrder.indexOf(b.id)
				);
			});
		},
		addTicket(index) {
			if (this.ticketCount === 6) {
				return;
			}
			this.mergedPrices[index].count = this.mergedPrices[index].count + 1;
			this.ticketsArray.push(this.mergedPrices[index].id);
		},
		removeTicket(index) {
			if (this.mergedPrices[index].count === 0) {
				return;
			}
			this.mergedPrices[index].count = this.mergedPrices[index].count - 1;
			let id = this.mergedPrices[index].id;
			let position = this.ticketsArray.findIndex((num) => num === id);
			if (position !== -1) {
				this.ticketsArray.splice(position, 1);
			}
		},
		settingZone(index) {
			this.selectedZone = this.performanceZones[index].zone;
		},
		repopulateTicketsArray() {
			this.visibleTickets.forEach((ticket) => {
				for (let i = 0; i < ticket.count; i++) {
					this.ticketsArray.push(ticket.id);
				}
			});
		},
	},
	watch: {
		tourOptions: {
			handler(newVal) {
				if (this.dateToFind === null) {
					return;
				}
				this.datePicked = this.dateToFind;
				this.dateToFind = null;
			},
			deep: true,
		},
		datePicked(dp) {
			if (dp === null || dp === undefined) {
				return;
			}
			this.resetOnDatePicked();
			let targetDate = new Date(dp).toISOString().split('T')[0];
			let matchingEvent = this.rawDataEvents.find((ev) => {
				let evDate = new Date(ev.PerformanceDate).toISOString().split('T')[0];
				return evDate === targetDate;
			});
			this.eventId = matchingEvent.PerformanceId;
			setTimeout(() => {
				this.$refs['tourTickets'].scrollIntoView({ behavior: 'smooth' });
			}, '1500');
		},
		eventId(id) {
			if (id === null || id === undefined) {
				return;
			}
			this.getPerformanceZones(id);
			this.getPriceTypes(id);
		},
		startDate(val) {
			if (val !== null && this.endDate !== null) this.getTessEvents();
		},
		rawDataEvents(newEvents) {
			if (!newEvents || newEvents.length === 0) return;
			// Step 1: Convert PerformanceDates to Date objects
			let dateArray = newEvents
				.map((ev) => new Date(ev.PerformanceDate))
				.filter((date) => !isNaN(date)) // Just in case there's a bad date
				.sort((a, b) => a - b); // Step 2: Sort ascending

			// Step 3: Get first and last date
			let startDate = dateArray[0];
			let endDate = dateArray[dateArray.length - 1];

			// Step 4: Format as YYYY-MM-DD
			const formatDate = (date) => date.toISOString().split('T')[0]; // "2025-04-15"

			// Step 5: Set to component state
			let start = new Date(formatDate(startDate));
			let end = new Date(formatDate(endDate));
			this.tourOptions[0].to = start;
			this.tourOptions[0].from = end;
			this.tourOptions[0].dates = this.getMissingDates(start, end, dateArray);
			setTimeout(() => {
				this.$refs['calendar'].scrollIntoView({ behavior: 'smooth' });
			}, '500');
		},
		priceTypes(vals) {
			if (!vals || vals.length === 0) return;
			this.getTicketText();
		},
		ticketTextInfo(text) {
			if (!text || text.length === 0) return;
			this.mergeTicketValues();
		},
		showAllTickets(bool) {
			if (this.mergedPrices === null) {
				return;
			}
			this.ticketsArray = [];
			this.repopulateTicketsArray();
		},
	},
	computed: {
		ticketCount() {
			return this.ticketsArray.length;
		},
		visibleTickets() {
			if (this.mergedPrices === null) {
				return null;
			}
			return this.showAllTickets
				? this.mergedPrices
				: this.mergedPrices.slice(0, 4);
		},
	},
};
</script>
